import { checkParams, zeroUnit, soFarDate } from '../../utils'
import { formatTime, formatDate, formatDatetime } from '../../filter'

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this
	if (this.isResurveyNotInHospital || this.isSimpleVisit) {
		return false
	}

	let arr = []

	const hasCaregivers = !(
		injured.caregiversDto &&
		['0', ''].includes(injured.caregiversDto.hasCaregivers)
	)

	if (hasCaregivers) {
		let list = [{}]
		if (
			injured.caregiversDto &&
			injured.caregiversDto.caregiversInfoList.length
		) {
			list = injured.caregiversDto.caregiversInfoList
		}

		for (const item of list) {
			if (this.isFirstVisit && this.isPAIC) {
				arr.push([
					{
						label: '护理人身份',
						value: setting.caregiversIdentityMap[item.caregiversIdentity],
					},
					{
						label: '姓名',
						value: item.caregiversName,
					},
					{
						label: '工作单位',
						value: item.workingPlace,
					},
					{
						label: '收入/收费',
						value: zeroUnit(
							item.nursingCost,
							item.caregiversIdentity === '01' ? '元/月' : '元/日'
						),
					},
					{
						label: '护理起止时间',
						value: formatDate(item.beginTime) + '至' + formatDate(item.endTime),
					},
					{
						label: '备注（非必填）',
						value: item.remark,
					},
				])
			}
			//平安定制
			if (!this.isPAIC) {
				arr.push([
					{
						label: '护理人身份',
						value: setting.caregiversIdentityMap[item.caregiversIdentity],
					},
					{
						label: '姓名',
						value: item.caregiversName,
					},
					{
						label: '工作单位',
						value: item.workingPlace,
					},
					{
						label: '岗位名称',
						value: item.jobName,
					},
					{
						label: '收入/收费',
						value: zeroUnit(
							item.nursingCost,
							item.caregiversIdentity === '01' ? '元/月' : '元/日'
						),
					},
					{
						label: '备注（非必填）',
						value: item.remark,
					},
				])
			}
		}
	}

	const obj = {
		title: '护理人信息',
		children: arr,
		show: {
			hasCaregivers,
		},
	}

	return obj
}
